
import { defineComponent, ref, computed, onMounted, onUnmounted } from "vue";
import store from "@/store";
import router from "@/router";
import NativeClient, { TitleInfo } from "@/client/native-client";
import DateUtil from "@/utils/date-util";
import {
  UsedUpPantryItem,
  UsedUpPantryList,
  DeletePantryInfo,
  DetetePantryItem,
  DetetePantryPlateItem,
  DetetePantryFridgeItem,
  PLATE_DELETE_FOOD_STATUS,
  RequestShoppingFoods,
  RequestShoppingFood,
  FridgeItemsJudgeData,
  FridgeItemsJudge,
  RequestFridgeItemsConfirm,
  FridgeDeleteItem,
  SaveDeleteFoodItemData,
  SaveDeleteFoodItem,
  FridgeConfirmItem,
  SaveAddFoodItemData,
  RegisterScanIngredients,
  RegisterScanIngredient,
  RequestFoodUpdate,
  DetetePantryConfirmItem,
  RequestRecipeFoods,
  FridgeConfirmItemInfo,
  PANTRY_DEFAULT_STORAGE_TYPE
} from "@/types/pantry";
import { useApiErrorHandler } from "@/use/use-api-error-handler";
import { useApiErrorDialog } from "@/use/use-api-error-dialog";
import PantryUsedUpCheckView from "@/components/pantry/PantryUsedUpCheckView.vue";
import PantryUsedUpTitleView from "@/components/pantry/PantryUsedUpTitleView.vue";
import PantryUsedUpEmptyView from "@/components/pantry/PantryUsedUpEmptyView.vue";
import CommonDesignDialog from "@/components/common/CommonDesignDialog.vue";
import { pantry } from "@/store/pantry";
import PantryUtil from "@/utils/pantry-util";
import CommonUtil from "@/utils/common-utils";
export default defineComponent({
  name: "PantryUsedUpCheckPage",
  components: {
    PantryUsedUpCheckView,
    CommonDesignDialog,
    PantryUsedUpTitleView,
    PantryUsedUpEmptyView
  },
  setup() {
    const COMPLTE_DIALOG_SHOPPTING = "このまま買い物リストに追加へ";
    const ERROR_BUTTON_LABEL = "OK";
    const isShowComplite = ref(false);
    const usedUpPantryList = ref(new UsedUpPantryList());
    const usedUpPantryDeleteList = ref(new UsedUpPantryList());
    const shoppingFoods = new RequestShoppingFoods();
    const isShowCameraList = ref(false);
    const isShowBack = ref(false);
    // カメラ専用の食材情報
    const fridgeItemsJudege = ref(new FridgeItemsJudgeData());
    const completeDialogMessageShopping = ref("");
    let cameraApplianceId = "";
    /** APIリクエスト時のエラーハンドル */
    const {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage
    } = useApiErrorHandler();
    /** ダイアログの制御 */
    const { closeDialog } = useApiErrorDialog();
    NativeClient.showCloseButton(false);
    NativeClient.setTitle(new TitleInfo(false, ""));
    isShowBack.value = true;
    const getPantyList = () => {
      const result:FridgeItemsJudge = store.getters["pantry/getFridgeItemsJudge"];
      const saveFoodItems:SaveDeleteFoodItemData = store.getters["pantry/getSaveDeleteFoodItems"]
      NativeClient.sendDebugLog("PantryAddPage setFridgeItemsJudge result=" + result);
      NativeClient.sendDebugLog(
        "PantryUseupCheckPage pantryList result=" + JSON.stringify(result)
      );
      const list = new Array<UsedUpPantryItem>();
      const deleteList = new Array<UsedUpPantryItem>();
      if (result != null && result.usedUpCandidateItems != null) {
        let i = 0;
        for (const pantryItem of result.usedUpCandidateItems) {
          const item = new UsedUpPantryItem(i, pantryItem);
          if (saveFoodItems != null && saveFoodItems.pantryDeleteItems) {
            const saveItem = saveFoodItems.getPantyDeleteItem(item.id);
            if (saveItem != null) {
              item.foodStatus = saveItem.foodStatus;
            }
          }
          deleteList.push(item);
          i++;
        }
      }
      if (result != null && result.pantryItems != null) {
        let i = 0;
        for (const pantryItem of result.pantryItems) {
          const item = new UsedUpPantryItem(i, pantryItem);
          if (saveFoodItems != null && saveFoodItems.pantryDeleteItems) {
            const saveItem = saveFoodItems.getPantyItem(item.id);
            if (saveItem != null) {
              item.foodStatus = saveItem.foodStatus;
            }
          }
          list.push(item);
          i++;
        }
      }
      fridgeItemsJudege.value.response = result;
      usedUpPantryList.value.list = list;
      usedUpPantryDeleteList.value.list = deleteList;
    };

    const requestUsedUpCheck = async () => {
      NativeClient.sendDebugLog("PantryUseupCheckPage requestUsedUpCheck");
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        cameraApplianceId = PantryUtil.getCameraApplianceId();
        const apiBaseParams = store.getters["common/getApiBaseParams"];
        Promise.all([
          store.dispatch("pantry/getFridgeItemsJudge")
        ]).then(result => {
          isShowCameraList.value = cameraApplianceId != "";
          getPantyList();
          store.dispatch("common/stopLoading");
        });
      });
    };
    /*
     * レシピ詳細の取得を実行する
     */
    const execute = async () => {
      requestUsedUpCheck();
    };

    const retryGetPantry = () => {
      execute();
    };

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(async () => {
      execute();
    });

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onUnmounted(async () => {
      // 画面から離れた場合
    });

    const saveDeleteFoodData = () => {
      const deleteItems = new SaveDeleteFoodItemData();
      const list = new Array<SaveDeleteFoodItem>();
      const deleteList = new Array<SaveDeleteFoodItem>();
      if (usedUpPantryDeleteList.value.list) {
        usedUpPantryDeleteList.value.list.forEach(item => {
          if (item.foodStatus != PLATE_DELETE_FOOD_STATUS.NONE) {
            deleteList.push(new SaveDeleteFoodItem(item.id, item.foodStatus));
          }
        });
      }
      if (usedUpPantryList.value.list) {
        usedUpPantryList.value.list.forEach(item => {
          if (item.foodStatus != PLATE_DELETE_FOOD_STATUS.NONE) {
            list.push(new SaveDeleteFoodItem(item.id, item.foodStatus));
          }
        });
      }
      NativeClient.sendDebugLog(
        "PantryUseupCheckPage saveDeleteFoodData deleteList=" +
          JSON.stringify(deleteList)
      );
      NativeClient.sendDebugLog(
        "PantryUseupCheckPage saveDeleteFoodData list=" +
          JSON.stringify(list)
      );
      deleteItems.pantryItems = list;
      deleteItems.pantryDeleteItems = deleteList;
      store.dispatch("pantry/updateSaveDeleteFoodItems", deleteItems);
    }

    const clickBack = () => {
      isShowBack.value = false;
      saveDeleteFoodData();
      window.setTimeout(() => {
        router.go(-1);
      }, 25);
    };

    const onSelectTag = (data: UsedUpPantryItem, foodStatus: number) => {
      NativeClient.sendDebugLog(
        "PantryUseupCheckPage onSelectTag foodStatus=" +
          foodStatus +
          " data=" +
          JSON.stringify(data)
      );
      if (data == null) {
        return;
      }
      if (usedUpPantryList.value.list != null) {
        usedUpPantryList.value.list.forEach(item => {
          if (item.id == data.id) {
            if (item.foodStatus != foodStatus) {
              item.foodStatus = foodStatus;
            }
          }
        });
      }
    };

    const onSelectDeleteTag = (data: UsedUpPantryItem, foodStatus: number) => {
      NativeClient.sendDebugLog(
        "PantryUseupCheckPage onSelectDeleteTag foodStatus=" +
          foodStatus +
          " data=" +
          JSON.stringify(data)
      );
      if (data == null) {
        return;
      }
      if (usedUpPantryDeleteList.value.list != null) {
        usedUpPantryDeleteList.value.list.forEach(item => {
          if (item.id == data.id) {
            if (item.foodStatus != foodStatus) {
              item.foodStatus = foodStatus;
            }
          }
        });
      }
    };

    const updateIngredeintExpirationDays = (pantryList: Array<RegisterScanIngredient>) => {
      const foodMap = store.getters["pantry/getRecipeFoodMap"];
      if (foodMap != null && pantryList.length != 0) {
        for (const item of pantryList) {
          const foodId = item.ingredientId;
          const shelfLive = foodMap.getDefineShelfLive(foodId);
          if (shelfLive != null) {
            item.expirationDays = shelfLive.shelfLife;
            // shelfTypeから保存場所を取得する
            const storageType = PantryUtil.convertServerStorageType(shelfLive.shelfType);
            item.storageType = storageType;
          }
          if (item.storageType == null) {
            item.storageType = PANTRY_DEFAULT_STORAGE_TYPE;
          }
          NativeClient.sendDebugLog("PantryUseupCheckPage updateIngredeintExpirationDays item=" + JSON.stringify(item));
        }
      }
      return pantryList;
    }

    const updateConfirm = (confirmItemInfos: Array<FridgeConfirmItemInfo>) => {
      const foodMap = store.getters["pantry/getRecipeFoodMap"];
      let confirmItems = null;
      if (confirmItemInfos.length != 0) {
        confirmItems = new Array<FridgeConfirmItem>();
        for(const item of confirmItemInfos) {
          if (foodMap != null) {
            const foodId = item.foodId;
            if (foodId != null) {
              const shelfLive = foodMap.getShelfTypeShelfLive(foodId, "vegetable");
              if (shelfLive != null) {
                item.item.expirationDays = shelfLive.shelfLife;
              }
            }
            NativeClient.sendDebugLog("PantryUseupCheckPage updateConfirm item=" + JSON.stringify(item));
          }
          confirmItems.push(item.item);
        }
      }
      return confirmItems;
    }

    const requestDeletePantry = async () => {
      store.dispatch("common/startLoading");
      const saveAddFoodItems:SaveAddFoodItemData = store.getters["pantry/getSaveAddFoodItems"]
      const addPayload = null;
      const deletePayload = new DeletePantryInfo();
      const deletePantryConfirmItems = Array<DetetePantryConfirmItem>();
      const fridgeDeleteItems =  Array<FridgeDeleteItem>();
      const confirmItems = Array<FridgeConfirmItemInfo>();
      const ingredeintList = new Array<RegisterScanIngredient>();
      const date = DateUtil.getToday();
      shoppingFoods.foods = [];
      if (saveAddFoodItems) {
        if (saveAddFoodItems.fridgeItems) { 
          saveAddFoodItems.fridgeItems.forEach(item => {
            if (item.inferenceResultFoodId != null) {
              let foodId = null;
              if (item.ingredientId != null && item.ingredientId != -1) {
                if (item.ingredientId != item.defaultIngredientId) {
                  foodId = item.ingredientId;
                } else {
                  foodId = item.defaultIngredientId;
                }
              }
              const confirmItem = new FridgeConfirmItem(item.inferenceResultFoodId, item);
              confirmItems.push(new FridgeConfirmItemInfo(foodId, confirmItem));
            }
          });
        }
        if (saveAddFoodItems.purChasedItems) {
          saveAddFoodItems.purChasedItems.forEach(item => {
            if (item.ingredientId != null) {
              ingredeintList.push(new RegisterScanIngredient(item.ingredientId, date, null));
            }
          });
        }
        if (saveAddFoodItems.rankingItems) {
          saveAddFoodItems.rankingItems.forEach(item => {
            if (item.ingredientId != null) {
              ingredeintList.push(new RegisterScanIngredient(item.ingredientId, date, null));
            }
          });
        }
        if (saveAddFoodItems.favoriteItems) {
          saveAddFoodItems.favoriteItems.forEach(item => {
            if (item.ingredientId != null) {
              ingredeintList.push(new RegisterScanIngredient(item.ingredientId, date, null));
            }
          });
        }
        if (saveAddFoodItems.categoryItems) {
          saveAddFoodItems.categoryItems.forEach(category => {
            category.genreList.forEach(genre => {
              genre.foodList.forEach(item => {
                if (item.ingredientId != null) {
                  ingredeintList.push(new RegisterScanIngredient(item.ingredientId, date, null));
                }
              });
            });
          });
        }
      }
      const ingredeintPayload = new RegisterScanIngredients(ingredeintList);
      // 食材リスト
      if (usedUpPantryList.value.list != null) {
        usedUpPantryList.value.list.forEach(item => {
          if (item.foodStatus != PLATE_DELETE_FOOD_STATUS.NONE) {
            if (item.info.pantryId != null) {
              deletePayload.pantryList.push(
                new DetetePantryItem(item.info.pantryId, item.foodStatus)
              );
              const deleteItem = new DetetePantryConfirmItem();
              deleteItem.pantryId = item.info.pantryId;
              deleteItem.foodStatus = item.foodStatus;
              deletePantryConfirmItems.push(deleteItem);
            } else if (item.info.pantryPlateId != null) {
              deletePayload.pantryPlateList.push(
                new DetetePantryPlateItem(
                  item.info.pantryPlateId,
                  item.foodStatus
                )
              );
              const deleteItem = new DetetePantryConfirmItem();
              deleteItem.pantryPlateId = item.info.pantryPlateId;
              deleteItem.foodStatus = item.foodStatus;
              deletePantryConfirmItems.push(deleteItem);
            } else if (item.info.pantryFridgeId != null) {
              deletePayload.pantryFridgeList.push(
                new DetetePantryFridgeItem(
                  item.info.pantryFridgeId,
                  item.foodStatus
                )
              );
              const deleteItem = new DetetePantryConfirmItem();
              deleteItem.pantryFridgeId = item.info.pantryFridgeId;
              deleteItem.foodStatus = item.foodStatus;
              deletePantryConfirmItems.push(deleteItem);
            }
            shoppingFoods.foods.push(new RequestShoppingFood(item.info.ingredientId, item.info.name));
          }
        });
      }
      // カメラから見えなくなったもの
      if (usedUpPantryDeleteList.value.list != null) {
        usedUpPantryDeleteList.value.list.forEach(item => {
          if (item.foodStatus != PLATE_DELETE_FOOD_STATUS.NONE) {
            if (item.info.pantryFridgeId != null) {
              fridgeDeleteItems.push(
                new FridgeDeleteItem(
                  item.info.pantryFridgeId,
                  item.foodStatus
                )
              );
            }
            shoppingFoods.foods.push(new RequestShoppingFood(item.info.ingredientId, item.info.name));
          }
        });
      }
      NativeClient.sendDebugLog(
        "PantryUseupCheckPage requestDeletePantry deletePayload=" +
          JSON.stringify(deletePayload)
      );
      NativeClient.sendDebugLog(
        "PantryUseupCheckPage requestDeletePantry fridgeDeleteItems=" +
          JSON.stringify(fridgeDeleteItems)
      );
      NativeClient.sendDebugLog(
        "PantryUseupCheckPage requestDeletePantry deletePantryConfirmItems=" +
          JSON.stringify(deletePantryConfirmItems)
      );
      NativeClient.sendDebugLog(
        "PantryUseupCheckPage requestDeletePantry fridgeItemsJudege=" +
          JSON.stringify(fridgeItemsJudege.value)
      );
      NativeClient.sendDebugLog(
        "PantryUseupCheckPage requestDeletePantry confirmItems=" +
          JSON.stringify(confirmItems)
      );
      NativeClient.sendDebugLog(
        "PantryUseupCheckPage requestDeletePantry ingredeintPayload=" +
          JSON.stringify(ingredeintPayload)
      );
      completeDialogMessageShopping.value = (shoppingFoods.foods.length != 0) ? COMPLTE_DIALOG_SHOPPTING : "";
      if (
        ingredeintPayload.pantryList.length == 0 &&
        deletePayload.pantryList.length == 0 &&
        deletePayload.pantryPlateList.length == 0 &&
        deletePayload.pantryFridgeList.length == 0 &&
        confirmItems.length == 0 &&
        fridgeDeleteItems.length == 0
      ) {
        isShowComplite.value = true;
        store.dispatch("common/stopLoading");
        NativeClient.requestUpdatePantryList();
        return;
      }
      const payloadFoods = new RequestRecipeFoods();
      for (const item of ingredeintPayload.pantryList) {
        const foodId = item.ingredientId;
        if (payloadFoods.ids.indexOf(foodId) == -1) {
          payloadFoods.ids.push(foodId);
        }
      }
      for (const item of confirmItems) {
        const foodId = item.foodId;
        if (foodId != null && payloadFoods.ids.indexOf(foodId) == -1) {
          payloadFoods.ids.push(foodId);
        }
      }
      NativeClient.sendDebugLog(
        "PantryUseupCheckPage requestDeletePantry payloadFoods=" + JSON.stringify(payloadFoods)
      );
      const apiBaseParams = store.getters["common/getApiBaseParams"];
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        Promise.all([store.dispatch("pantry/getRecipeFoodMap", payloadFoods)]).then(
        result => {
          const foodMap = store.getters["pantry/getRecipeFoodMap"];
          if (foodMap != null) {
            NativeClient.sendDebugLog("PantryUseupCheckPage updateConfirm foodMap=" + CommonUtil.jsonStringify(foodMap.map));
          }
          const payloadFoodUpdate = new RequestFoodUpdate();
          if (ingredeintPayload.pantryList.length != 0) {
            ingredeintPayload.pantryList = updateIngredeintExpirationDays(ingredeintPayload.pantryList);
            payloadFoodUpdate.ingredients = ingredeintPayload;
          }
          if (fridgeItemsJudege.value.isCamera()) {
            const key = fridgeItemsJudege.value.response != null ? fridgeItemsJudege.value.response.pantryJudgeKey : "";
            const confirmPayload = new RequestFridgeItemsConfirm(key);
            // カメラから見えなくなったもの
            if (fridgeDeleteItems.length != 0) {
              confirmPayload.deleteItems = fridgeDeleteItems;
            }
            // カメラ認識
            if (confirmItems.length != 0) {
              confirmPayload.confirmItems = updateConfirm(confirmItems);
            }
            // 食材リスト
            if (deletePantryConfirmItems.length != 0) {
              confirmPayload.deletePantryItems = deletePantryConfirmItems;
            }
            if (confirmItems.length != 0 || fridgeDeleteItems.length != 0 || deletePantryConfirmItems.length != 0) {
              payloadFoodUpdate.confirm = confirmPayload;
            }
          } else {
            if (
              deletePayload.pantryList.length != 0 ||
              deletePayload.pantryPlateList.length != 0 ||
              deletePayload.pantryFridgeList.length != 0
            ) {
              payloadFoodUpdate.delete = deletePayload;
            }
          }
          Promise.all([store.dispatch("pantry/setFoodUpdate", payloadFoodUpdate)]).then(
          result => {
            NativeClient.sendDebugLog(
              "PantryUseupCheckPage requestDeletePantry result"
            );
            isShowComplite.value = true;
            store.dispatch("common/stopLoading");
            NativeClient.requestUpdatePantryList();
            return;
          });
        });
      });
    };

    const isSelectEmpty = () => {
      let isEmpty = true;
      if (usedUpPantryList.value.list != null) {
        for (const item of usedUpPantryList.value.list) {
          if (item.foodStatus != PLATE_DELETE_FOOD_STATUS.NONE) {
            isEmpty = false;
            break;
          }
        }
      }
      if (usedUpPantryDeleteList.value.list != null) {
        for (const item of usedUpPantryDeleteList.value.list) {
          if (item.foodStatus != PLATE_DELETE_FOOD_STATUS.NONE) {
            isEmpty = false;
            break;
          }
        }
      }
      return isEmpty;
    };

    const onClickBottom = () => {
      NativeClient.sendDebugLog("PantryUseupCheckPage onClickBottom");
      requestDeletePantry();
    };

    const onClickCompliteButton = () => {
      isShowComplite.value = false;
      // モーダル表示の場合はNativeで画面を終了する
      NativeClient.pageClose();
    };

    const onClickCompliteText = () => {
      NativeClient.sendDebugLog(
        "PantryUseupCheckPage onClickCompliteText length=" + shoppingFoods.foods.length
      );
      if (shoppingFoods.foods.length != 0) {
        isShowComplite.value = false;
        // モーダル表示の場合はNativeで画面を終了する
        NativeClient.pageClose();
        NativeClient.transitionShoppingList();
      }
    };

    const onClickCamera = async () => {
      // 起動前に連携機器のApplianceIdを取得する
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const applianceId = PantryUtil.getCameraApplianceId();
        NativeClient.sendDebugLog(
          "PantryUsedUpCheckPage onClickCamera applianceId=" + applianceId
        );
        if (applianceId == null || applianceId == "") {
          return;
        }
        NativeClient.transitionPantryCamera();
      });
    };

    const isEmptyPantryDeleteList = () => {
      return isShowCameraList.value && usedUpPantryDeleteList.value.list != null && usedUpPantryDeleteList.value.list.length == 0;
    };

    const isEmptyPantryList = () => {
      return usedUpPantryList.value.list != null && usedUpPantryList.value.list.length == 0;
    };

    const getBottomMessage = () => {
      return isSelectEmpty() ? "次へ" : "登録する";
    };

    const closeError = () => {
      closeDialog();
    };

    return {
      closeDialog,
      retryGetPantry,
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage,
      clickBack,
      usedUpPantryList,
      onSelectTag,
      isShowComplite,
      onClickBottom,
      onClickCompliteButton,
      onClickCompliteText,
      onClickCamera,
      usedUpPantryDeleteList,
      onSelectDeleteTag,
      isShowCameraList,
      isEmptyPantryDeleteList,
      isEmptyPantryList,
      isShowBack,
      getBottomMessage,
      completeDialogMessageShopping,
      closeError,
      ERROR_BUTTON_LABEL
    };
  }
});
